import { filterSpecBySkuModules, isSkuModuleEnabled } from '../../_shared/common/sku/skuEnabledModules';
import type { MsSpec } from './schema';

const DISABLED_LIMIT = { enabled: false, value: 0 } as const;

const MODULE_FIELD_STRIPS: Record<string, (spec: MsSpec) => MsSpec> = {
  baseInfo: (spec) => ({
    ...spec,
    alias: '',
    description: undefined,
    workspace: undefined,
  }),
  modelProvider: (spec) => ({
    ...spec,
    strategyName: undefined,
    strategyDisplayName: undefined,
    strategyProvider: undefined,
    providerPricing: undefined,
    llmgwStrategyRef: undefined,
    // Token 配额（总量 / 输入输出）归属模型供应商
    resourceLimits: spec.resourceLimits
      ? {
          ...spec.resourceLimits,
          billingTotalTokens: DISABLED_LIMIT,
          inputTokens: DISABLED_LIMIT,
          outputTokens: DISABLED_LIMIT,
        }
      : undefined,
  }),
  other: (spec) => ({
    ...spec,
    allowedClientCIDRs: [],
    allowedClientIPs: [],
    rateLimits: undefined,
    // 仅清高级项；不触碰 Token 配额
    resourceLimits: spec.resourceLimits
      ? {
          ...spec.resourceLimits,
          requests: DISABLED_LIMIT,
        }
      : undefined,
    switches: {
      showTokenLimit: false,
      showRequests: false,
      showInputTokens: false,
      showOutputTokens: false,
    },
  }),
};

/** 按 SKU enabledModules 裁剪 spec，防止未选模块泄漏到 resourceConfigs / preset / apiBody */
export function filterMsSpecByEnabledModules(spec: MsSpec, enabledModules?: Record<string, boolean>, skuType?: 'fixed' | 'custom'): MsSpec {
  return filterSpecBySkuModules(spec, MODULE_FIELD_STRIPS, enabledModules, skuType);
}

export function isMsModuleEnabled(moduleKey: string, enabledModules?: Record<string, boolean>, skuType?: 'fixed' | 'custom'): boolean {
  return isSkuModuleEnabled(moduleKey, enabledModules, skuType);
}
